import {HelperFunctions, isEmpty,} from "@/scripts/Common/HelperFunctions";
import {TopUpRotation,} from "@/Enums";
import {useCardLimites} from "@/composables/useCardLimites";
import {useGratificationSettings} from "@/composables/useGratificationSettings";
import moment from "moment";

const maxDecimals = 2;
const restrictedRotations = [TopUpRotation.Monthly];

const {
  error: cardLimiteError,
  cardLimite
} = useCardLimites();

const {
  error: gratificationError,
  gratificationSettings
} = useGratificationSettings();

const hasValidAmount = (amount: number, rotation: TopUpRotation) => {
  if (gratificationError.value || cardLimiteError.value) return false;

  //Rotation Gratification and maximum charge amount
  if (amount > gratificationSettings.value.maximumAmountPerCharge && rotation === TopUpRotation.Gratification) return false;

  //Rotation None is allowed without an Amount
  if ((!amount || amount === 0) && rotation === TopUpRotation.None) return true;

  //Else there must be a value
  if (!amount) return false;

  //Check if amount is smaller or equal than 0
  if (amount <= 0) return false;

  //Check if decimals are more than allowed decimals
  if (HelperFunctions.GetDecimalsCount(amount.toString()) > maxDecimals) return false;

  //Check if amount is bigger than max card limite
  if (amount > cardLimite.value.maxCardLimit) return false;

  //Check if amount is bigger than top up limit per month
  if (amount > cardLimite.value.topUpLimitPerMonth) return false;

  //Check if amount is bigger than maxMonthlyTopUp
  return !(restrictedRotations.includes(rotation)
    && amount > cardLimite.value.maxMonthlyTopUpAmount);

}

/**
 * rotation end is valid if it is not empty and the current date is before the rotation end
 * and the next charging date (if set) is also before the rotation end
 */
const hasValidRotationEnd = (rotationEnd: string | undefined, nextChargingDate: string | undefined) => {
  if (isEmpty(rotationEnd)) return true;

  const now = new Date().getTime();
  const configuredRotationEnd = new Date(rotationEnd!).getTime();
  const configuredNextChargingDate = !isEmpty(nextChargingDate) ? new Date(nextChargingDate!).getTime() : undefined;

  return !isNaN(configuredRotationEnd) && now < configuredRotationEnd &&
    (configuredNextChargingDate === undefined ||
      (!!configuredNextChargingDate && configuredNextChargingDate! < configuredRotationEnd));
}

/**
 * Check if the date is tomorrow or later.
 * Empty date returns false.
 * Invalid date returns false.
 * @param date - the date to check
 * @returns {boolean} true if the date is tomorrow or later, false otherwise
 */
const dateIsAfterToday = (date: string | undefined): boolean => {
  if (!date || !moment(date).isValid()) return false;

  const tomorrow = moment().add(1, 'days').startOf('day');

  return moment(date).isSameOrAfter(tomorrow);
}

export {
  hasValidAmount,
  hasValidRotationEnd,
  dateIsAfterToday
}
